import { SwapKitNumber } from "@swapkit/core";

import { ForgeListing } from "../schema";
import { ForgeModels } from "./ForgeModels";
import { suggestedThornames } from "./mockData";
import { ForgeTNS } from "./types";

export const parseListing =
  (_ctx: (typeof ForgeModels)["prototype"]) =>
  (listing: ForgeListing): ForgeTNS => {
    const listingPrice = SwapKitNumber.fromBigInt(BigInt(listing?.price)).getValue("number");
    const name = listing?.name?.toLowerCase();

    return {
      ...suggestedThornames?.[0],
      ...listing,
      name,
      type: "listing",
      nameWithExtension: `${name}.thor`,
      price: {
        rune: listingPrice,
        usd: listingPrice * (_ctx.runeUSDPrice || 1),
      },
      activity: [],
      activeOffers: [],
      entries: [],
    };
  };
